import React from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { INotificationModalProps } from '../types';
import { useTimeout } from 'beautiful-react-hooks';
import styles from '../Modals.module.css';

export const NotificationModal: React.FC<INotificationModalProps> = ({
  title,
  message,
  icon,
  kind,
  timeout,
  onRequestClose,
}) => {
  useTimeout(() => {
    if (timeout) {
      onRequestClose();
    }
  }, timeout || 0);

  return (
    <Modal isOpen className="model-content" overlayClassName="modal-overlay">
      <span className={styles.title}>{title}</span>
      <FontAwesomeIcon
        className={`${styles.icon} text-${kind}`}
        icon={icon}
        size="4x"
      />
      <p>{message}</p>
      {!timeout && <Button onClick={onRequestClose}>OK</Button>}
    </Modal>
  );
};
